//トップページのヘッダー写真下のS4の円のロゴのフェードイン

var $ = require('jquery');

$(function(){
  'use strict';

  function getHeroHeight() {
    var heroHeight = $('.s4-Hero').height() / 4;
    return heroHeight;
  }

  $(window).on('load resize', function(){
    getHeroHeight();
  });

  $(window).on('scroll', function(){

    if($(this).scrollTop() > getHeroHeight()) {
      $('.js-s4-Logo').addClass('is-show');
    }
  });
});